import React from 'react'

const Footer = () => {
  return (
    <footer className='center'>
              <span>
            <div className="social">
                <a href="https://www.facebook.com/indrapal.panwar.5"><i className="fab fa-facebook" aria-hidden="true"></i></a>&nbsp;
                <a href="https://wa.me/919927071840"><i className="fab fa-whatsapp" aria-hidden="true"></i></a>&nbsp;
                <a href="https://www.linkedin.com/in/sanidhya-panwar-824504180/"><i className="fab fa-linkedin" aria-hidden="true"></i></a>
            </div>
        </span>
        <span>Created By <a href="https://sanidhyapanwar.herokuapp.com/">Sanidhya Panwar</a></span>
    </footer>
  )
}

export default Footer
